import { useState } from "react";
import { HandHeart } from "lucide-react";
import { AyatCard } from "@/components/hte/AyatCard";
import { Boxes, LayerSection } from "@/components/hte/LayerSection";
import { RelatedAyat } from "@/components/hte/RelatedAyat";
import { ResultActions } from "@/components/hte/ResultActions";
import { TafsirExcerpts } from "@/components/hte/TafsirExcerpts";
import { TweakBox } from "@/components/hte/TweakBox";
import { LAYERS } from "@/lib/hte";

const QBody = ({ d }) => (
  <>
    <div>
      <div className="eyebrow mb-2">Mesej teras</div>
      <p className="text-base text-ink leading-relaxed" data-testid="q-mesej-teras">{d.q.mesej_teras}</p>
    </div>
    <div>
      <div className="eyebrow mb-3">Pandangan mufassir</div>
      <ul className="space-y-3" data-testid="q-mufassir-list">
        {d.q.pandangan_mufassir.map((p, i) => (
          <li key={i} className="rounded-xl border border-line p-4" data-testid={`mufassir-${p.tafsir}`}>
            <div className="arabic-sm text-lg text-q text-right" lang="ar">{p.nama_ar}</div>
            <p className="text-sm text-ink leading-relaxed mt-1">{p.ringkasan}</p>
          </li>
        ))}
      </ul>
    </div>
    {d.q.ayat_berkaitan.length > 0 && (
      <div>
        <div className="eyebrow mb-3">Ayat berkaitan</div>
        <ul className="grid sm:grid-cols-2 gap-2">{d.q.ayat_berkaitan.map((a, i) => <RelatedAyat key={i} item={a} index={i} />)}</ul>
      </div>
    )}
    <TafsirExcerpts ayatRef={d.ayat_ref} />
  </>
);

const IBody = ({ d }) => (
  <div className="grid md:grid-cols-3 gap-3">
    {d.i.map((x, n) => (
      <div key={n} className="rounded-xl p-4 bg-i-soft" data-testid={`inovasi-${n}`}>
        <div className="font-mono-data text-xs text-i">0{n + 1}</div>
        <div className="font-display text-lg text-ink mt-1">{x.nama}</div>
        <p className="text-sm text-ink/90 leading-relaxed mt-2">{x.huraian}</p>
      </div>
    ))}
  </div>
);

export const HteResult = ({ kajian, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  const d = kajian.current;
  const [Q, V, K, I] = LAYERS;
  const owner = kajian.is_owner !== false;
  const tweak = (key) => owner && <TweakBox layerKey={key} kajianId={kajian.id} onUpdated={onUpdated} disabled={busy} setBusy={setBusy} />;
  return (
    <div className={`space-y-8 transition-opacity ${busy ? "opacity-80" : ""}`} data-testid="hte-result">
      <AyatCard d={d} />
      <div className="relative">
        <span className="absolute left-5 sm:left-6 top-6 bottom-6 w-px descent-line" aria-hidden="true" />
        <div className="space-y-12" key={kajian.version_count}>
          <LayerSection layer={Q}><QBody d={d} />{tweak("q")}</LayerSection>
          <LayerSection layer={V} delay={80}><Boxes layerKey="v" items={[["Nilai", d.v.nilai], ["Prinsip", d.v.prinsip], ["Budaya", d.v.budaya]]} />{tweak("v")}</LayerSection>
          <LayerSection layer={K} delay={160}><Boxes layerKey="k" items={[["Ilmu", d.k.ilmu], ["Kemahiran", d.k.kemahiran], ["Sistem", d.k.sistem]]} />{tweak("k")}</LayerSection>
          <LayerSection layer={I} delay={240}><IBody d={d} />{tweak("i")}</LayerSection>
        </div>
      </div>
      <section className="rounded-2xl p-6 sm:p-8 border-2 border-[var(--q)] bg-q-soft fade-up" data-testid="amanah-box">
        <div className="flex items-center gap-2 eyebrow !text-q"><HandHeart size={15} /> Amanah 7 hari</div>
        <p className="font-display text-xl text-ink mt-3 leading-snug">{d.amanah}</p>
      </section>
      <ResultActions kajian={kajian} onUpdated={onUpdated} busy={busy} owner={owner} />
    </div>
  );
};
